module.exports = __webpack_public_path__ + "static/images/title-bg.c5dcc81.png";